const TURKISH_CHAR_MAP: Record<string, string> = {
  ı: 'i',
  İ: 'i',
  I: 'i',
  ş: 's',
  Ş: 's',
  ğ: 'g',
  Ğ: 'g',
  ü: 'u',
  Ü: 'u',
  ö: 'o',
  Ö: 'o',
  ç: 'c',
  Ç: 'c',
};

export function normalizeTurkish(text: string): string {
  return text
    .split('')
    .map((char) => TURKISH_CHAR_MAP[char] ?? char)
    .join('')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

export function toSearchSlug(query: string): string {
  return normalizeTurkish(query)
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function fromSearchSlug(slug: string): string {
  return decodeURIComponent(slug).replace(/-/g, ' ').trim();
}

export const SEARCH_LABEL_COOKIE = 'habercom_search_label';

export function sanitizeSearchLabel(raw: string): string {
  return String(raw || '')
    .replace(/<[^>]*>/g, '')
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .replace(/[<>"'`]/g, '')
    .slice(0, 120)
    .trim();
}

export function resolveSearchLabel(
  slug: string,
  cookieLabel: string | undefined,
  fallback: string,
): string {
  if (!cookieLabel) return sanitizeSearchLabel(fallback);

  const label = sanitizeSearchLabel(decodeURIComponent(cookieLabel));
  if (!label || toSearchSlug(label) !== slug) {
    return sanitizeSearchLabel(fallback);
  }

  return label;
}

export function buildSearchPageUrl(query: string, page = 1): string {
  const slug = toSearchSlug(query);
  if (!slug) return '/arama';
  if (page <= 1) return `/arama/${slug}`;
  return `/arama/${slug}/${page}`;
}

export function parseSearchPath(parts: string[]): { query: string; page: number } {
  if (parts.length === 0) {
    return { query: '', page: 1 };
  }

  const last = parts[parts.length - 1];
  if (parts.length > 1 && /^\d+$/.test(last)) {
    return {
      query: fromSearchSlug(parts.slice(0, -1).join('/')),
      page: Math.max(1, parseInt(last, 10)),
    };
  }

  return {
    query: fromSearchSlug(parts.join('/')),
    page: 1,
  };
}
